import { useEffect } from 'react';
import type { PolicyFormSectionProps } from './PolicyFormSection';
import { SelectWithUnitsFormGroup, TextAreaFormGroup } from '../../../../processActivityFormGroupFields';
import { weeksOptions } from '../weeksOptions';

export function NoChosenTreatmentFields(props: Readonly<PolicyFormSectionProps>) {
    const { data, onChange } = props;

    useEffect(() => {
        if (data.callPatientAfterWeeks === null) {
            onChange({ callPatientAfterWeeks: 2 }, 'callPatientAfterWeeks');
        }
    }, []);

    return (
        <>
            <TextAreaFormGroup
                fieldKey="remarkNoTreatment"
                isRequired={true}
                label="Toelichting"
            />

            <SelectWithUnitsFormGroup
                fieldKey="callPatientAfterWeeks"
                isClearable={false}
                isRequired={true}
                label="Poli belt patiënt terug na"
                onChange={async (value) => {
                    onChange({ callPatientAfterWeeks: parseInt(value ?? '') ?? null }, 'callPatientAfterWeeks');
                }}
                options={weeksOptions}
                units="weken"
                value={data.callPatientAfterWeeks?.toString()}
            />
        </>
    );
}
